//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import couponLine from '@/components/coupon/index.vue'
import popupLayer from '@/components/popup-layer/popup-layer.vue';
import addressList from './address/list.vue';
import addressInfo from './address/info.vue';
import paymentSelect from '@/components/paymentSelect/index.vue'
export default {
	data(){
		return {
			payInfo:{					
			},
			boolShow:false,
			price:0,
			message:'',
			countPrice:0,
			couponCode: '',
			productIds: [],
			showName:'list',
			info:{
			},
			orderId:'',
			ids:'',
			id:'',
			showPaymentSelect:false,
			submitLoading:false,
			address:{
				cityName:''
			},
			addressList:[],
			coupons:[]
		}
	},
	components:{
		couponLine,
		popupLayer,addressList,addressInfo,
		paymentSelect
		// payType
	},
	computed: {
		payPrice () {
		  if (this.payInfo.isCar) {
			let productId = this.ids.split(',')
			let productIds = this.productIds
			let ff = this.payInfo.checkList
			let priceMoney = 0 // 使用优惠券
			productIds.forEach((e, indexA) => {
			  let c = productId.findIndex((v, index) => {
				if (v === e) {
				  productId.splice(index, 1, '')
				  return v === e
				}
			  })
			  priceMoney += ff[c].singlePrice * ff[c].quantity
			})
			if (priceMoney === 0) {
			  return this.price
			} else {
			  return parseFloat((priceMoney - this.countPrice) > 0 ? (priceMoney - this.countPrice) : 0.01 + (this.price - priceMoney)).toFixed(2)
			}
		  } else {
			return parseFloat((this.price - this.countPrice) > 0 ? (this.price - this.countPrice) : 0.01).toFixed(2)
		  }
		}
	  },
	methods:{
		changePrice (msg) {
		  this.countPrice = msg.couponDenomination
		  this.couponCode = msg.childCouponCode
		  this.productIds = msg.productIds[0]
		},
		getList(){
			let _this=this
			return this.$ajax({
				method: 'post',
				url: '/weChat/specialtyProduct/queryDeliveryAddressList',
				data: {
					// memberId:'599267700576878592'
				  	memberId: this.$store.state.userInfo.memberId
				}
			}).then(res=>{
				if(res.data.deliveryAddressList.length) {
					_this.addressList=res.data.deliveryAddressList
					return res.data.deliveryAddressList[0]
					// _this.info=_this.addressList[0]
					// _this.info.address=_this.info.provinceName+_this.info.cityName+_this.info.districtName+_this.info.detailAddress
				}
			})
		},
		onSubmit () {
			let _this=this
			if (this.testName() && this.testPhone()) {
				if (this.info.provinceName !== '') {
					if (this.submitLoading) {
						return false
					} else {
						this.submitLoading = true
						let _data = {
							createOrderSource: this.payInfo.isCar ? 0 : 1,
							// memberId:'599267700576878592',
							memberId:this.$store.state.userInfo.memberId,
							// memberId: uni.getStorageSync('memberId'),
							deliveryName: this.info.receiverName,
							orderPhone: this.info.phone,
							deliveryAddress: this.info.provinceName+this.info.cityName+this.info.districtName+this.info.detailAddress,
							// transportPrice: 0, // 运费
							couponCode: this.couponCode || '', // 优惠券编码
							customerComments: this.message, // 买家留言
							isDiscount: this.couponCode ? 1 : 0, // 是否使用优惠券
							totalQuantity: this.payInfo.total, // 产品总量
							totalPrice: this.price, // 订单总价
							payPrice: this.payPrice, // 实付金额
							// isRefund: 0, // 退订规则
							orderName: this.info.receiverName, // 预订人姓名
							createSpecialtyOrderInfos: JSON.stringify(this.payInfo.checkList)
						}
						this.$ajax({
							method: 'post',
							url: '/weChat/specialtyOrder/createOrder',
							data: _data
						}).then(res=>{
							if(res.success) {
								_this.orderId = res.data
								_this.showPaymentSelect = true
								_this.submitLoading = false
							}
							
						}).catch(res=>{
							_this.submitLoading = false
						})
					}
				} else {
					uni.showToast({
						title:'地址不能为空！',
						icon:'none'
					})
				}
			} else {
				uni.showToast({
					title:'必填项不能为空！',
					icon:'none'
				})
			}
		},
		handelClose () {
			this.showPaymentSelect = false
			this.submitLoading = false
		},
		choseAddress(item){
			this.info=item
		},
		changeMessage(val){
			this.message=val.detail.value
		},
		editAddress(item){				
			this.$refs.info.edit(item)				
			this.showName='info'
		},
		hide(){
			this.boolShow=false
		},
		upShowName(val){
			if(val==='info'){
				this.$refs.info.reset()
			}
			this.showName=val
		},
		select(){
			this.boolShow=true
			this.showName='list'
		},
		testName () {
			return (
				!!this.info.receiverName &&
				/^[\u4e00-\u9fa5.a-zA-Z0-9]+$/.test(this.info.receiverName)
			)
		},
		testPhone () {
			return /^1[345789]\d{9}$/.test(this.info.phone)
		}
	},
	async onReady() {
		this.payInfo=uni.getStorageSync('payInfo')		
		let res= await this.getList()
		if(res){
			this.info=res
			this.info.address=res.provinceName+res.cityName+res.districtName+res.detailAddress
		}
		
		this.price=this.payInfo.price			
		this.ids=this.payInfo.checkList.map(ele=>{
			return ele.storeProductId
		}).join(',')
		this.id=this.ids
		// this.getCoupon()
	}
}
